import {
  BenefitsContextProvider,
  DasbhoardInformations,
  DashboardAccount,
  DashboardBenefits,
  DashboardContextProvider,
  DashboardDocument,
  DashboardPage,
  DashboardSponsorship,
  LeisureOrderShow,
  OrdersTable,
  TravelOrderShow
} from 'components';
import { ProtectedRoute } from 'router';

export const dashboardRoutes = {
  dashboard: {
    path: '/dashboard',
    component: () => (
      <ProtectedRoute>
        <DashboardContextProvider>
          <DashboardPage />
        </DashboardContextProvider>
      </ProtectedRoute>
    ),
    children: {
      account: {
        path: '/dashboard/mon-compte',
        component: () => (
          <ProtectedRoute>
            <DashboardAccount />
          </ProtectedRoute>
        )
      },
      benefits: {
        path: '/dashboard/mes-avantages',
        component: () => (
          <ProtectedRoute>
            <BenefitsContextProvider>
              <DashboardBenefits />
            </BenefitsContextProvider>
          </ProtectedRoute>
        )
      },
      documents: {
        path: '/dashboard/mes-demandes',
        component: () => (
          <ProtectedRoute>
            <DashboardDocument />
          </ProtectedRoute>
        )
      },
      informations: {
        path: '/dashboard/mes-informations',
        component: () => (
          <ProtectedRoute>
            <DasbhoardInformations />
          </ProtectedRoute>
        )
      },
      orders: {
        path: '/dashboard/mes-commandes',
        component: () => (
          <ProtectedRoute>
            <OrdersTable dashboardOrder />
          </ProtectedRoute>
        )
      },
      travelOrderShow: {
        path: '/dashboard/mes-commandes/voyages/:id',
        component: () => (
          <ProtectedRoute>
            <TravelOrderShow />
          </ProtectedRoute>
        )
      },
      leisureOrderShow: {
        path: '/dashboard/mes-commandes/loisirs/:id',
        component: () => (
          <ProtectedRoute>
            <LeisureOrderShow />
          </ProtectedRoute>
        )
      },
      sponsorship: {
        path: '/dashboard/mes-parrainages',
        component: () => (
          <ProtectedRoute>
            <DashboardSponsorship />
          </ProtectedRoute>
        )
      }
    }
  }
};
